import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { FacetSortSelectComponent } from './facet-sort-select.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        SortSelect: {
          component: FacetSortSelectComponent,
        },
      },
    }),
  ],
})
export class FacetSortSelectModule {}
